"use client";

import { useState } from "react";
import { Link } from "react-router-dom"; // added useNavigate
import backgroundImage from "./2.jpg";
import logoImage from "../../public/media/combined_images/logo.png";
import "./login.css";

export default function Page() {
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); // new loading state


const handleSubmit = (event) => {
  event.preventDefault();

  setIsLoading(true);
  setMessage("");

  // No API call — just show the error message
  setTimeout(() => {
    setMessage("Your credentials are incorrect. Please contact LIMS.");
    setIsLoading(false);
  }, 500);
};


  return (
    <main className="login-shell">
      <div
        className="login-background"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      />

      {/* Background Overlay */}
      <div className="login-vignette" />

      {/* Login Card */}
      <section className="login-card" aria-labelledby="login-title">
        {/* ================= LEFT SIDE ================= */}
        <div className="login-left">
          <div className="lims-logo">
            <img src={logoImage} alt="LIMS" />
          </div>
        </div>

        {/* ================= RIGHT SIDE ================= */}
        <div className="login-right">
          <h1 id="login-title">Member Login</h1>

          {/* ================= LOGIN FORM ================= */}
          <form onSubmit={handleSubmit} className="login-form">
            {/* Email (used as username) */}
            <div className="input-wrap">
              <span className="input-icon" aria-hidden="true">
                ✉
              </span>

              <input
                id="email"
                name="email"
                type="email"
                placeholder="Email"
                autoComplete="email"
                required
              />
            </div>

            {/* Password */}
            <div className="input-wrap">
              <span className="input-icon" aria-hidden="true">
                🔒
              </span>

              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                autoComplete="current-password"
                required
              />

              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((value) => !value)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>

            {/* Login Button */}
            <button className="login-button" type="submit" disabled={isLoading}>
              {isLoading ? "Logging in..." : "LOGIN"}
            </button>
          </form>

          {/* ================= MESSAGE ================= */}
          {message && (
            <p className="form-message" role="status" style={{color:'red'}}>
              {message}
            </p>
          )}

          {/* ================= INFORMATION ================= */}
          <div className="info-copy">
            {/* Not a member */}
            <p className="info-item">
              <span className="green-dot" aria-hidden="true" />

              <Link
                to="/MapPage"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <strong>Not a Member?</strong> Get Free access of 14-days
                weather forecast, soil and water data.
              </Link>
            </p>

            {/* Small farmers */}
            <p className="info-item">
              <span className="green-dot" aria-hidden="true" />
              <Link to="/">
                <strong>Attention small farmers!</strong> Lims provides free of
                cost Crop Monitoring upto 12 Acres. Please{" "}
              </Link>
              <Link to="/">
                <strong>contact us</strong>
              </Link>
              .
            </p>
          </div>

          {/* ================= RESOURCE LINKS ================= */}
          <nav className="resource-links" aria-label="Resources">
            <Link to="/manual">Download Manual</Link>

            <span>|</span>

            <Link to="/video-tutorial">Video Tutorial</Link>

            <span>|</span>

            <Link to="/monitoring-tutorial">Monitoring Tutorial</Link>

            <span>|</span>

            <Link to="/vegetation-indices">Vegetation Indices</Link>
          </nav>
        </div>
      </section>
    </main>
  );
}